import { Component, ViewChild } from '@angular/core';
declare var bootstrap: any;
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { CustomToastsService } from 'src/app/Services/custom-toasts.service';
import { UserPermissionsModel } from 'src/app/Models/ApplicationModels';
import { AdminBreadcrumbsService } from '../../../../admin-services/admin-breadcrumbs.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { AddWeekColorsComponent } from '../add-week-colors/add-week-colors.component';
import {
  ProductionCycle,
  ProductionCycleSchedule,
} from '../../models/week-color.model';
import { OverrideStatus, Status } from 'src/app/enum/enum';
import { WeekColorService } from '../../services/week-color.service';

@Component({
  selector: 'app-week-colors',
  templateUrl: './week-colors.component.html',
  styleUrls: ['./week-colors.component.css'],
})
export class WeekColorsComponent {
  @ViewChild(AddWeekColorsComponent)
  addWeekColorsComponent!: AddWeekColorsComponent;

  weekColorsList: Array<ProductionCycle> = [];
  activeWeekColorsList: Array<ProductionCycle> = [];
  productioncycleSchedules: Array<ProductionCycleSchedule> = [];
  currentTab: 'schedule' | 'active' | 'inactive' = 'schedule';
  companyId: number = 0;
  isButtonActive: OverrideStatus = OverrideStatus.Active;
  selectedRowIndex: number | null = null;
  headerCheckboxSelected: boolean = false;
  selectedproductionCycleIDs: string[] = [];

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private weekColorService: WeekColorService,
    private toastr: CustomToastsService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
  ) {}

  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Company Config', link: 'demo' },
      { crumbName: 'Week Colors', link: '/admin/home/week-colors' },
    ]);

    this.getCompanyId();
    this.getProductionCycles();
    this.getProductionCycleSchedule();
    this.getPermissionsByUserId();
  }

  private getCompanyId(): void {
    const details = localStorage.getItem('user');
    if (details) {
      const userDetails = JSON.parse(details);
      this.companyId = userDetails.companyID;
    }
  }

  getProductionCycles(): void {
    this.weekColorService
      .getProductionCycles(this.companyId)
      .subscribe((res) => {
        const allColors = res as ProductionCycle[];
        this.weekColorsList = allColors.filter(
          (item) => item.status === this.isButtonActive,
        );
        this.activeWeekColorsList = allColors.filter(
          (item) => item.status === OverrideStatus.Active,
        );
      });
  }

  getProductionCycleSchedule(): void {
    this.weekColorService
      .getProductionCycleSchedule(this.companyId)
      .subscribe((res) => {
        this.productioncycleSchedules = res as ProductionCycleSchedule[];
      });
  }

  activeTab(isActive: boolean): void {
    this.isButtonActive = isActive
      ? OverrideStatus.Active
      : OverrideStatus.Inactive;
    this.getProductionCycles();
  }

  setTab(tab: 'schedule' | 'active' | 'inactive'): void {
    this.currentTab = tab;
    if (tab === 'active') this.activeTab(true);
    else if (tab === 'inactive') this.activeTab(false);
    else {
      this.getProductionCycleSchedule();
    }
    this.uncheckSelectedCheckboxes();
  }

  highlightedRow(id: any): void {
    this.selectedRowIndex = id;
  }

  toggleAllCheckboxes(): void {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (this.headerCheckboxSelected) {
      this.selectedproductionCycleIDs = this.weekColorsList.map((color) =>
        color.id.toString(),
      );
    } else {
      this.selectedproductionCycleIDs = [];
    }
  }

  handleCheckboxChange(event: any, weekcolor: ProductionCycle): void {
    if (event.target.checked) {
      weekcolor.isSelected = true;
      this.selectedproductionCycleIDs.push(weekcolor.id.toString());
    } else {
      const index = this.selectedproductionCycleIDs.indexOf(
        weekcolor.id.toString(),
      );
      if (index !== -1) {
        this.selectedproductionCycleIDs.splice(index, 1);
      }
    }
  }

  uncheckSelectedCheckboxes(): void {
    this.selectedproductionCycleIDs = [];
    this.headerCheckboxSelected = false;
    this.weekColorsList?.forEach((w) => (w.isSelected = false));
  }

  // Drag and drop handling
  MoveWeekColorRow(event: CdkDragDrop<string[]>): void {
    moveItemInArray(
      this.weekColorsList,
      event.previousIndex,
      event.currentIndex,
    );
    this.updateWeekColorsSortOrder();
  }

  private updateWeekColorsSortOrder(): void {
    this.weekColorsList.forEach((ele, i) => {
      ele.companyId = this.companyId;
      ele.sortOrder = i + 1;
    });

    this.weekColorService
      .updateProductionCycleSortOrder(this.weekColorsList)
      .subscribe(
        (result) => {
          if (!result) {
            this.toastr.error('Sort order update failed');
          }
        },
        (err) => {
          this.toastr.error('An error occurred while updating sort order');
        },
      );
  }

  onEditWeekColor(id: number): void {
    this.highlightedRow(id);
    if (this.addWeekColorsComponent) {
      this.addWeekColorsComponent.loadProductionCycle(id);
    }
  }

  onDeleteWeekColor(id: number): void {
    this.highlightedRow(id);
    if (this.addWeekColorsComponent) {
      this.addWeekColorsComponent.confirmDelete(id);
    }
  }

  onBulkDelete(): void {
    if (!this.addWeekColorsComponent) return;

    const ids = this.selectedproductionCycleIDs.length
      ? this.selectedproductionCycleIDs.map((id) => parseInt(id))
      : [];
    this.addWeekColorsComponent.confirmBulkDelete(ids);
    const trigger = document.getElementById('confirmTrigger') as HTMLButtonElement | null;
    if (trigger) {
      trigger.click();
      return;
    }

    const el = document.getElementById('confirmationDialog');
    if (el) {
      try {
        const modal = bootstrap.Modal.getOrCreateInstance(el);
        modal.show();
      } catch (e) {
      }
    }
  }

  onMarkAsActive(): void {
    if (
      this.selectedproductionCycleIDs.length > 0 &&
      this.addWeekColorsComponent
    ) {
      const ids = this.selectedproductionCycleIDs.map((id) => parseInt(id));
      this.addWeekColorsComponent.markAsActive(ids);
    }
  }

  onWeekColorSaved(): void {
    this.getProductionCycles();
    this.uncheckSelectedCheckboxes();
  }

  onScheduleSaved(): void {
    this.getProductionCycleSchedule();
    this.currentTab = 'schedule';
    this.uncheckSelectedCheckboxes();
  }

  onWeekColorDeleted(): void {
    this.getProductionCycles();
    this.uncheckSelectedCheckboxes();
    this.highlightedRow(null);
  }

  private getPermissionsByUserId(): void {
    this.userservice.getUserRolesandPerm().then((res) => {
      const permissions = res as UserPermissionsModel[];
      const perm: string[] = permissions?.map((pr) => pr.name) || [];
      this.permissionService.loadPermissions(perm);
    });
  }
}